import { useContext } from "react";
import { TaskListSettingsContext } from "contexts/task-list-settings/task-list-settings";

export const useTaskSettings = () => useContext(TaskListSettingsContext);
